import { Loader2 } from "lucide-react";

const Fallback = ({ type, src }) => {
  if (type === "mug") return (
    <div className="relative mx-auto w-40 h-36"><div className="absolute inset-y-2 left-0 w-32 rounded-b-3xl rounded-t-lg bg-white border-2 border-[#1E1B26] overflow-hidden"><img src={src} alt="" className="h-full w-full object-cover" /></div><div className="absolute right-0 top-8 h-16 w-10 rounded-r-full border-[6px] border-l-0 border-[#1E1B26]" /></div>);
  if (type === "tshirt") return (
    <div className="relative mx-auto w-44 h-44 bg-[#F5F0E8] rounded-t-[3rem] rounded-b-xl border-2 border-[#1E1B26] grid place-items-center"><img src={src} alt="" className="w-24 h-24 object-cover rounded-lg" /></div>);
  return <div className="mx-auto w-32 h-44 bg-white p-2 border-2 border-[#1E1B26] shadow-lg"><img src={src} alt="" className="h-full w-full object-cover" /></div>;
};

const Thumbs = ({ urls, active, onPick }) => (
  <div className="mt-3 flex gap-2 overflow-x-auto" data-testid="merch-mockup-thumbs">
    {urls.map((u, i) => (
      <button key={u} type="button" onClick={() => onPick(i)} data-testid={`merch-mockup-thumb-${i}`}
        className={`h-14 w-14 shrink-0 rounded-xl overflow-hidden border-2 transition-colors ${i === active ? "border-[#1E1B26]" : "border-transparent"}`}>
        <img src={u} alt="" className="h-full w-full object-cover" />
      </button>
    ))}
  </div>
);

export const MockupPreview = ({ mock, active, onPick, type, src }) => {
  const ready = !mock.loading && mock.urls.length > 0;
  return (
    <>
      <div className="relative rounded-3xl bg-[#FFF0F3] overflow-hidden aspect-square grid place-items-center" data-testid="merch-preview">
        {mock.loading && (
          <div className="absolute inset-0 shimmer grid place-items-center" data-testid="merch-mockup-loading">
            <span className="flex items-center gap-2 text-sm font-semibold text-[#6E687A]"><Loader2 className="h-4 w-4 animate-spin" /> Printing a preview...</span>
          </div>
        )}
        {ready && <img src={mock.urls[active]} alt="Product mockup" className="h-full w-full object-cover rise" data-testid="merch-mockup-image" />}
        {!mock.loading && !mock.urls.length && <Fallback type={type} src={src} />}
        {ready && <span className="absolute top-3 left-3 rounded-full bg-white/90 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider">Real print preview</span>}
      </div>
      {ready && mock.urls.length > 1 && <Thumbs urls={mock.urls} active={active} onPick={onPick} />}
    </>
  );
};
